import { isUndefined } from 'lodash-es';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import useRedirectRoute from '../../../api/login/sideEffects/useRedirectRoute';

const ProtectedRoute = () => {
  const { isLoggedIn } = useAuthContext();
  const { clearRedirect } = useRedirectRoute();

  if (isUndefined(isLoggedIn)) {
    return null;
  }
  const redirectTo = window.location.href.split(window.location.host)[1];

  if (isLoggedIn) {
    clearRedirect();
    return <Outlet />;
  }

  return <Navigate to={`/${redirectTo ? '?redirect=' + redirectTo : ''}`} replace />;
};

export default ProtectedRoute;
